<template>
  <div class="search-page">
    <search-bar @search="onSearch()" :placeholder="placeholder" ref="searchBar" />
    <scroll-list v-if="searching" @refresh="onSearch" @loadpage="onSearch($event,1)">
      <router-link
        class="reco__item weui-cell weui-cell_access"
        v-for="item in result.content"
        :key="item.id"
        :to="'/doc/'+item.projectCode+'/'+item.itemCode"
      >
        <div class="weui-cell__bd">
          <div class="reco-item__hd">
            <h5 v-html="item.itemName"></h5>
            <span class="reco-item__group">{{item.projectName}}</span>
          </div>
          <div class="reco-item__bd">
            <div class="reco-item__desc" v-html="item.brief"></div>
          </div>
        </div>
        <div class="weui-cell__ft"></div>
      </router-link>
      <template v-slot:bbar>
        <p class="result__tips">为您找到{{result.totalElements}}个相关结果</p>
      </template>
    </scroll-list>
  </div>
</template>
<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";

export default {
  props: {
    placeholder: String
  },
  components: {
    SearchBar,
    ScrollList
  },
  data() {
    return {
      searching: false,
      number: 1,
      size: 10,
      blength: 96,
      result: {
        totalElements: 0,
        content: []
      }
    };
  },
  methods: {
    onSearch(callback, next) {
      var me = this,
        searchBar = me.$refs.searchBar,
        keyword = searchBar.getValue(),
        params;
      if (!keyword) {
        me.searching = false;
        return;
      }
      params = {
        keyword: keyword,
        number: next && me.result.content.length ? me.number + 1 : 1,
        size: me.size,
        blength: me.blength
      };
      me.$loading({
        url: "/api/help/article/search",
        params
      }).then(function(res) {
        me.searching = true;
        callback && callback.call(me);
        if (res.success) {
          var data = res.data;
          if (next) {
            if (data.content.length) {
              me.number = params.number;
              me.result.totalElements = data.totalElements;
              me.result.content = me.result.content.concat(data.content);
            }
          } else {
            me.number = 1;
            me.result = data;
          }
        } else {
          me.number = 1;
          me.result = {
            totalElements: 0,
            content: []
          };
        }
      });
    }
  }
};
</script>

<style>
.search-page .list {
  background: #fff;
  position: absolute;
  top: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  z-index: 501;
}
.result__tips {
  text-align: center;
  text-transform: uppercase;
  margin: 10px 0;
  color: var(--weui-FG-2);
  font-size: 12px;
}

.reco-item__hd h5 {
  display: inline-block;
  vertical-align: middle;
  font-size: 17px;
}

.reco-item__hd .reco-item__group {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  padding: 0 5px;
  border-radius: 3px;
  border: 1px solid #222;
  vertical-align: middle;
  display: inline-block;
  transform: scale(0.84);
}

.reco-item__desc {
  color: var(--weui-FG-1);
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.42;
}
.search-page em {
  font-style: normal;
  color: var(--weui-BRAND);
}
</style>